import styled from 'styled-components';

export const VerticalLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
